import { Fragment, useState, useEffect, useRef, useMemo } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  InputGroup,
  Label,
  Button,
  ButtonGroup,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert as RSAlert,
  UncontrolledTooltip,
  InputGroupText,
  Popover,
  PopoverBody,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Alert from "react-s-alert-v3";
import classnames from "classnames";
import { confirmAlert } from "react-confirm-alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, ui_helpers, date_helpers } from "../../helpers";
import Card from "@repay/react-credit-card";
import {
  RecurringPaymentModal,
  CaptureACH,
  CCSwipeParser,
  Loading,
  PaymentInformationModal,
  TransferNowModal,
} from "../";
import _ from "lodash";
import { storage, constants } from "../../utils";
import {
  StartTablet,
  GetNumberOfTabletPoints,
  GetTabletPNG64ImageString,
  ClearTabletSurface,
  DeactivateTablet,
} from "../../utils/SigWebTabletv1";
import Select from "react-select";
import usePosHub from "../../hooks/usePosHub";
import ToggleButton from "react-toggle-button";
import moment from "moment";
import { PriceAdjustmentEditor } from "./";
import { default as useContractStore } from "./utils/useContractStore";
import { default as useUserStore } from "../../hooks/useUserStore";
import { DebounceInput } from "react-debounce-input";

const BLOCK_EXIT_MESSAGE = "One or more price adjustments have not been saved. Please save or clear your pending changes.";
let tabletHandle = null;

function TransferRow({ transfer, openTransferNowDropdownId, agreementNumber,
  dealerCards, dealerBankAccounts, setOpenTransferNowDropdownId, setOpenTransferPopoverId,
  setSelectedDealerCard, onAddTransferPayment, setTransferPaymentReceived,
  setSelectedDealerBankAccount, setPaymentTransferModalOpen, setCreditCardOrAch, changeTransferType,
  setChangeTransferType, canSetRetained, isSysAdmin, isCashSale, onUpdateTransferType,
  submittingTransferPaymentId
}) {
  const isSubmitting = submittingTransferPaymentId != null
    && submittingTransferPaymentId === transfer.contractPaymentId;
  const isMail = transfer.paymentTransferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.MAIL;
  const isNow = transfer.paymentTransferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW;
  const isRetained = transfer.paymentTransferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED;
  const isLater = transfer.paymentTransferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.LATER;
  const isProcessed = transfer.processedAt;
  const paidOrReceivedAt = (isMail ? transfer.receivedAt : transfer.paidAt) || "";
  const ableToEdit = (isSysAdmin && !transfer.processedAt)
                || (isSysAdmin && isMail && !transfer.receivedAt)
                || (isSysAdmin && isRetained);

  let typeLabel = "";
  switch (transfer.paymentTransferIntentTypeId) {
    case constants.PAYMENT_TRANSFER_TYPE_IDS.MAIL:
      typeLabel = "Mail";
      break;
    case constants.PAYMENT_TRANSFER_TYPE_IDS.NOW:
      typeLabel = "Now";
      break;
    case constants.PAYMENT_TRANSFER_TYPE_IDS.LATER:
      typeLabel = "Later";
      break;
    case constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED:
      typeLabel = "Retained";
      break;
    default:
      typeLabel = "";
      break;
  }

  let options = null;
  if (canSetRetained && isCashSale) {
    options = _.reject(constants.CASH_PAYMENT_TRANSFER_TYPES, (x) => x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW);
  } else if (canSetRetained && !isCashSale) {
    options = _.reject(constants.RTO_PAYMENT_TRANSFER_TYPES, (x) => x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW);
  } else if (isCashSale) {
    options = _.reject(
      constants.CASH_PAYMENT_TRANSFER_TYPES, (x) => x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED
        || x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW);
  } else {
    options = _.reject(
      constants.RTO_PAYMENT_TRANSFER_TYPES, (x) => x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED
        || x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW);
  }

  let detailsContent = [];
  if (isMail) {
    detailsContent.push((<>
      <Input title={transfer.receivedAt ? "Mark as Unreceived" : "Mark as Received"}
        type="checkbox"
        className="me-2"
        checked={!!transfer.receivedAt}
        onChange={() => setTransferPaymentReceived(transfer, !transfer.receivedAt)}
        style={{
          verticalAlign: "middle",
          marginBottom: 3,
          cursor: "pointer"
        }}
      />
      <Badge color={transfer.receivedAt ? "success" : "secondary"} style={{ verticalAlign: "middle" }}>
        {transfer.receivedAt ? "Mail Transfer Received" : "Mail Transfer Pending"}
      </Badge>
    </>));
  } else if (isNow) {
    detailsContent.push((<Badge color={isProcessed ? "success" : "secondary"}>
      {isProcessed ? "Processed Transfer" : "Unprocessed Transfer"}
    </Badge>));
  } else if (isLater && transfer.isTransferred) {
    detailsContent.push((<Badge color="info" className="ms-2">Transferred</Badge>));
  } else if (isLater) {
    detailsContent.push((<ButtonDropdown
        direction="down"
        isOpen={!isSubmitting && openTransferNowDropdownId === transfer.id}
        toggle={() => {
          if (isSubmitting) return;
          setOpenTransferNowDropdownId(openTransferNowDropdownId === transfer.id ? null : transfer.id);
        }}>
        <DropdownToggle color="success" size="sm" className="d-flex align-items-center" disabled={isSubmitting}>
          <span className="badge bg-success me-2">
            {isSubmitting ? "Processing..." : "Transfer Now"}
          </span>
          <FontAwesomeIcon icon={isSubmitting ? "spinner" : "caret-down"} spin={isSubmitting} />
        </DropdownToggle>
        <DropdownMenu>
        {/* {agreementNumber !== constants.CASH_SALE && _.map(dealerCards, (card) => (
          <DropdownItem
            key={`card-${card.value}`}
            onClick={() => {
              setOpenTransferNowDropdownId(null);
              setOpenTransferPopoverId(null);
              setSelectedDealerCard(card);
              onAddTransferPayment(transfer.contractPaymentId, constants.PAYMENT_TRANSFER_TYPE_IDS.NOW, card, transfer.amount);
            }}
          >
            Card: {card.label}
          </DropdownItem>
        ))} */}
        {_.map(dealerBankAccounts, (ach) => (
          <DropdownItem
            key={`ach-${ach.value}`}
            onClick={() => {
              setOpenTransferNowDropdownId(null);
              setOpenTransferPopoverId(null);
              setSelectedDealerBankAccount(ach);
              onAddTransferPayment(transfer.contractPaymentId, constants.PAYMENT_TRANSFER_TYPE_IDS.NOW, ach, transfer.amount);
            }}
          >
            ACH: {ach.label}
          </DropdownItem>
        ))}
        {isSysAdmin ? (
          <>
            <DropdownItem divider />
            <DropdownItem
              onClick={() => {
                setOpenTransferPopoverId(null);
                setPaymentTransferModalOpen(true);
                setCreditCardOrAch(null);
              }}
            >
              ➕ Add New...
            </DropdownItem>
          </>
        ) : (
        <>
          <DropdownItem divider />
          <DropdownItem>
            Please call the RTO Office to add a new transfer method
          </DropdownItem>
        </>
      )}
      </DropdownMenu>
    </ButtonDropdown>));
  } else if (isRetained) {
    detailsContent.push((<Badge color="dark">Retained</Badge>));
  }

  return (
    <tr key={transfer.id}>
      <td>{typeLabel}</td>
      <td>{transfer.identifier || ""}</td>
      <td>{isLater || (isMail && !transfer.receivedAt)
        ? ""
        : date_helpers.shortYearDateTimeFormat(paidOrReceivedAt)}
      </td>
      <td>
        {detailsContent}
        {changeTransferType && ableToEdit ? (
          <Select
            options={options}
            value={_.find(options, (o) => o.value === transfer.paymentTransferIntentTypeId)}
            onChange={(option) => onUpdateTransferType(transfer.id, option.value)}
            className="mt-2"
          />
        ) : null}
      </td>
      <td>
        {ableToEdit ? (
          <Button
            size="sm"
            onClick={() => setChangeTransferType(!changeTransferType)}
          >
            <FontAwesomeIcon icon={"edit"} />
          </Button>
        ) : null}
      </td>
    </tr>
  );
}

function TransferPopoverTD({ paymentId, transfers, openTransferPopoverId, toggleTransferPopover,
  openTransferNowDropdownId, agreementNumber, dealerCards, dealerBankAccounts, setTransferPaymentReceived,
  setOpenTransferNowDropdownId, setOpenTransferPopoverId, setSelectedDealerCard, onAddTransferPayment,
  setSelectedDealerBankAccount, setPaymentTransferModalOpen, setCreditCardOrAch, isSysAdmin, changeTransferType,
  setChangeTransferType, canSetRetained, isCashSale, onUpdateTransferType, submittingTransferPaymentId }) {
  return (
    <td className="items-center text-center">
    {transfers && transfers.length && transfers.length > 0 ? (
      <div>
        <Button
          id={`view-transfers-btn-${paymentId}`}
          color="secondary" size="sm"
          onClick={() => toggleTransferPopover(paymentId)}
        >
          View Transfers
        </Button>
        <Popover placement="auto"
          isOpen={openTransferPopoverId === paymentId}
          target={`view-transfers-btn-${paymentId}`}
          toggle={() => toggleTransferPopover(paymentId)}
          trigger="legacy"
          fade={false}
          className="transfer-popover"
        >
          <PopoverBody>
            <Table size="sm" bordered>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Number</th>
                  <th>Paid/Received At</th>
                  <th />
                  {isSysAdmin ? <th /> : null}
                </tr>
              </thead>
              <tbody>
              {_.map(transfers, (t) => {
                return (
                  <TransferRow
                    transfer={t}
                    openTransferNowDropdownId={openTransferNowDropdownId}
                    agreementNumber={agreementNumber}
                    // dealerCards={dealerCards}
                    dealerBankAccounts={dealerBankAccounts}
                    setOpenTransferNowDropdownId={setOpenTransferNowDropdownId}
                    setOpenTransferPopoverId={setOpenTransferPopoverId}
                    setSelectedDealerCard={setSelectedDealerCard}
                    onAddTransferPayment={onAddTransferPayment}
                    setTransferPaymentReceived={setTransferPaymentReceived}
                    setSelectedDealerBankAccount={setSelectedDealerBankAccount}
                    setPaymentTransferModalOpen={setPaymentTransferModalOpen}
                    setCreditCardOrAch={setCreditCardOrAch}
                    changeTransferType={changeTransferType}
                    setChangeTransferType={setChangeTransferType}
                    isSysAdmin={isSysAdmin}
                    canSetRetained={canSetRetained}
                    isCashSale={isCashSale}
                    onUpdateTransferType={onUpdateTransferType}
                    submittingTransferPaymentId={submittingTransferPaymentId}
                  />
                )}
              )}
              </tbody>
            </Table>
          </PopoverBody>
        </Popover>
      </div>
    ) : null}
    </td>
  );
}


export default function Payment(props) {
  const [signatureURL, setSignatureURL] = useState('');
  const [capturingSignature, setCapturingSignature] = useState(false);
  const [capturingRecurring, setCapturingRecurring] = useState(false);
  const [capturingCard, setCapturingCard] = useState(false);
  const [capturingACH, setCapturingACH] = useState(false);
  const [capturingCardManually, setCapturingCardManually] = useState(false);
  const [achPayment, setAchPayment] = useState(constants.defaultPayment);
  const [bankInformation, setBankInformation] = useState(constants.defaultBank);
  const [achValidation, setAchValidation] = useState(constants.defaultAchValidation);
  const [showAchValidation, setShowAchValidation] = useState(false);
  const [capturingSignatureLinkRecipient, setCapturingSignatureLinkRecipient] = useState(false);
  const [capturingContractCodeSignatureLinkRecipient, setCapturingContractCodeSignatureLinkRecipient] = useState(false);
  const [capturingSignaturePad, setCapturingSignaturePad] = useState(false);
  const [signatureRequestLinkSent, setSignatureRequestLinkSent] = useState(false);
  const [signatureLocations, setSignatureLocations] = useState(null);
  const [cardNo, setCardNo] = useState("");
  const [cardCVC, setCardCVC] = useState("");
  const [cardMMYY, setCardMMYY] = useState("");
  const [cardZip, setCardZip] = useState("");
  const [cardSwipe, setCardSwipe] = useState("");
  const [creditCardType, setCreditCardType] = useState(_.find(constants.CREDIT_CARD_TYPES, cc => cc.label === 'Visa'));
  const [recurringBillingAddress, setRecurringBillingAddress] = useState("");
  const [recurringBillingEmail, setRecurringBillingEmail] = useState("");
  const [recurringBillingPhone, setRecurringBillingPhone] = useState("");
  const [recurringBillingCity, setRecurringBillingCity] = useState("");
  const [recurringBillingState, setRecurringBillingState] = useState("");
  const [recurringBillingZip, setRecurringBillingZip] = useState("");
  const [ccExpiryMonth, setCcExpiryMonth] = useState("");
  const [ccExpiryYear, setCcExpiryYear] = useState("");
  const [ccFullName, setCcFullName] = useState("");
  const [achRoutingNo, setAchRoutingNo] = useState("");
  const [achAccountNo, setAchAccountNo] = useState("");
  const [achFullName, setAchFullName] = useState("");
  const [paymentTypeId, setPaymentTypeId] = useState(constants.PAYMENT_TYPE_IDS.CHECK);
  const [paymentIdentifier, setPaymentIdentifier] = useState("");
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [isInCityLimits, setIsInCityLimits] = useState(false);
  const [signatureLinkRecipient, setSignatureLinkRecipient] = useState("");
  const [isSysAdmin, setIsSysAdmin] = useState(false);
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);

  const currentUser = useUserStore(x => x.currentUser);

  const {
    contractId,
    companyId,
    customerPhone1,
    billingAddress1,
    billingCity,
    billingState,
    billingZip,
    dealerId,
    unitPrice,
    setUnitPrice,
    initialPaymentAmount,
    sideFeePayment,
    otherAmountCaption,
    paymentList,
    setPaymentList,
    priceAdjustments,
    isRTO,
    creditCardFeePercentage,
    unitPriceDisabled,
    paymentTypes,
    isTaxExempt,
    setIsTaxExempt,
    enableRecurringPayments,
    setEnableRecurringPayments,
    taxExemptionForm,
    setTaxExemptionForm,
    paymentDueDayOfMonth,
    cards,
    setCards,
    bankAccounts,
    setBankAccounts,
    taxRateString,
    setTaxRateString,
    taxAmount,
    setTaxAmount,
    deliveryCounty,
    setDeliveryCounty,
    subtotal,
    manualCard,
    setManualCard,
    balanceDue,
    screenWarnings,
    paymentTransferIntentId,
    setPaymentTransferIntentId,
    contractTransferPayments,
    setContractTransferPayments,
    pendingTransfer,
    setPendingTransfer,
    agreementNumber,
    companyAcceptsPayment,
    canSetRetained,
    contractType,
    typeOfContractStatus,
  } = useContractStore();

  const canvasRef = useRef(null);
  const cardSwipeRef = useRef(null);
  const [isPaying, setIsPaying] = useState(false);
  const [contractPasscode, setContractPasscode] = useState("");

  // payment transfer items
  const [submittingTransferPaymentId, setSubmittingTransferPaymentId] = useState(null);
  const [paymentTransferModalOpen, setPaymentTransferModalOpen] = useState(false);
  const [creditCardOrAch, setCreditCardOrAch] = useState(null);
  const [selectedDealerCard, setSelectedDealerCard] = useState(null);
  const [selectedDealerBankAccount, setSelectedDealerBankAccount] = useState(null);
  const [dealerCards, setDealerCards] = useState([]);
  const [dealerBankAccounts, setDealerBankAccounts] = useState([]);
  const [openTransferPopoverId, setOpenTransferPopoverId] = useState(null);
  const [openTransferNowDropdownId, setOpenTransferNowDropdownId] = useState(null);
  const toggleTransferPopover = (paymentId) => {
    setOpenTransferPopoverId(openTransferPopoverId === paymentId ? null : paymentId);
  };
  const [changeTransferType, setChangeTransferType] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [confirmTransfer, setConfirmTransfer] = useState(false);
  const [confirmTransferNow, setConfirmTransferNow] = useState(false);
  const isCashSale = contractType === constants.CONTRACT_TYPE.CASH_SALE;
  const paymentTransferOptions = useMemo(() => {
    let options = null;
    if (canSetRetained && isCashSale) {
      options = constants.CASH_PAYMENT_TRANSFER_TYPES;
    } else if (canSetRetained && !isCashSale) {
      options = constants.RTO_PAYMENT_TRANSFER_TYPES;
    } else if (isCashSale) {
      options = _.reject(constants.CASH_PAYMENT_TRANSFER_TYPES, (x) => x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED);
    } else {
      options = _.reject(constants.RTO_PAYMENT_TRANSFER_TYPES, (x) => x.value === constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED);
    }
    if (!companyAcceptsPayment?.achBank || !companyAcceptsPayment?.creditCards) {
      options = options.filter(
        (x) =>
          x.value !== constants.PAYMENT_TRANSFER_TYPE_IDS.NOW &&
          x.value !== constants.PAYMENT_TRANSFER_TYPE_IDS.LATER
      );
    }
    return options;
  }, [canSetRetained, companyAcceptsPayment]);

  const {
    sessionStarted,
    completedSignatures,
    contractFinalized,
    paymentInfo,
    recurringEnabled,
  } = usePosHub(contractId);

  useEffect(() => {
    if (recurringEnabled) {
      setEnableRecurringPayments(true);
      Alert.info("Customer has enabled recurring payments.");
    }
  }, [recurringEnabled]);

  useEffect(() => {
    setSelectedCard(cards.length
      ? cards[cards.length - 1]
      : null);
  }, [cards]);

  useEffect(() => {
    setSelectedBankAccount(bankAccounts.length
      ? bankAccounts[bankAccounts.length - 1]
      : null);
  }, [bankAccounts]);

  // useEffect(() => {
  //   if (contractId) {
  //     api.fetch("Signature/GetSignatureLocations/" + contractId)
  //       .then((res) => setSignatureLocations(res.data.data));
  //   }
  // }, [contractId]);

  useEffect(() => {
    setCreditCardOrAch(null);
    setIsSysAdmin(ui_helpers.isSystemAdministrator(currentUser));
    if (!contractId) return;
    api.post(`contract/GetContractAddonWithPrice/` + contractId).then(res => {
      if (res.data && res.data.success) {
        setUnitPrice(res.data.message.price);
        setContractPasscode(res.data.message.contractPasscode);
      }
    }).catch(err => console.error(err));
  }, []);

  useEffect(() => {
    setIsCompanyAdmin(companyId
      ? ui_helpers.isCompanyAdministrator(currentUser, companyId)
      : false);
  }, [companyId]);

  useEffect(() => {
    if (!dealerId) return;
    // loadDealerCCList();
    loadDealerACHList();
  }, [dealerId]);

  function onSetRecurringData(d) {
    api.post("contract/SetRecurringPaymentData", api.getRecurringPayload(contractId, d)).then((r) => {
      if (r.data.success) {
        setCapturingRecurring(false);
      } else {
        Alert.error(r.data.message);
      }
    }).catch((e) => console.error(e));
  }

  function onChangePaymentType(newPaymentTypeId) {
    setPaymentTypeId(newPaymentTypeId);
    if (!constants.PAYMENT_TYPE_IDS_REQUIRING_TRANSFER.includes(newPaymentTypeId)) {
      setPaymentTransferIntentId(null);
      setSelectedDealerCard(null);
      setSelectedDealerBankAccount(null);
    }
    if (newPaymentTypeId === constants.PAYMENT_TYPE_IDS.CREDIT_CARD) {
      loadCCList();
      setCapturingCard(true);
    } else if (newPaymentTypeId === constants.PAYMENT_TYPE_IDS.ACH_DEBIT) {
      loadACHList();
      setCapturingACH(true);
    }
  }

  function onChangeCardZip(newValue) {
    setCardZip(newValue);
    if (cardSwipeRef && cardSwipeRef.current && newValue.length === 5) {
      try {
        setTimeout(() => cardSwipeRef.current.focus(), 400);
      } catch {}
    }
  }

  function onUploadTaxExemptionForm(file) {
    const filePayload = {
      referenceId: contractId,
      file: file,
      typeOfAttachment: constants.ATTACHMENT_TYPE_IDS.TaxExemptionForm
    };
    setTaxExemptionForm(filePayload);
  }

  function saveSignature() {
    if (GetNumberOfTabletPoints() === 0) {
      Alert.error("Please sign before continuing");
      return;
    }
    DeactivateTablet(tabletHandle);
    tabletHandle = null;
    // this works when debugging and a delay is allowed, but not consistently without a delay :(
    setTimeout(() => {
      GetTabletPNG64ImageString(function (b64PNGString) {
        api
          .post("contract/SaveSignature", {
            contractId: contractId,
            signatureTypeId: constants.SIGNATURE_TYPE_IDS.CUSTOMER_CONTRACT,
            b64PNGString: b64PNGString,
          })
          .then((r) => {
            if (r.data.success) {
              setSignatureURL(r.data.message);
              closeSignatureCapture();
            } else {
              Alert.error(r.data.message);
            }
          })
          .catch((e) => console.error(e));
      });
    }, 500);
  }

  // function loadDealerCCList(selectLast) {
  //   if (!dealerId) return;
  //   api
  //     .fetch("store/DealerCCList/" + dealerId)
  //     .then((r) => {
  //       const cardList = _.map(r.data, (x) => ({
  //         label: x.secureDisplay,
  //         value: x.id,
  //         type: "card"
  //       }));
  //       setDealerCards(cardList);
  //       if (selectLast) {
  //         setSelectedDealerCard(cardList[cardList.length - 1]);
  //       }
  //     })
  //     .catch((e) => console.error(e));
  // }

  function loadCCList() {
    api.fetch("contract/ContractCCList/" + contractId).then((r) => {
      const cardList = _.map(r.data, (x) => ({
        label: x.secureDisplay,
        value: x.id,
      }));
      setCards(cardList);
      setSelectedCard(cardList.length ? cardList[cardList.length - 1] : null);
    }).catch((e) => console.error(e));
  }

  const loadACHList = () => {
    api.fetch(`contract/ContractACHList/${contractId}`).then((r) => {
      const bankList = _.map(r.data, (x) => ({
        label: x.secureDisplay,
        value: x.id
      }));
      setBankAccounts(bankList);
      setSelectedBankAccount(bankList.length ? bankList[bankList.length - 1] : null);
    }).catch((e) => console.error(e));
  };

  function saveACHDetails(achInfo) {
    if (!achInfo) return;
    const achPayment = {
      name: achInfo?.name || achInfo?.achFullName,
      routeNumber: achInfo?.routeNumber || achInfo?.achRoutingNo,
      accountNumber: achInfo?.accountNumber || achInfo?.achAccountNo,
      accountType: achInfo?.accountType?.label || achInfo?.achAccountType,
      dealerId: dealerId,
      bankName: achInfo?.bankName || achInfo?.achBankName,
      entryClass: achInfo?.entryClass || achInfo?.achEntryClass,
      type: achInfo?.type || achInfo?.achType
    };
    api
      .post(`store/SaveDealerACHDetails/${dealerId}`, achPayment)
      .then((response) => {
        if (response.data.success) {
          Alert.success("ACH details saved successfully");
          setCreditCardOrAch(null);
          setPaymentTransferModalOpen(false);
          loadDealerACHList(true);
        } else {
          Alert.error(response.data.message);
        }
      })
      .catch((error) => Alert.error("There was an error saving the ACH details."));
  }

  function loadDealerACHList(selectLast = true) {
    if (!dealerId) return;
    api
      .fetch("store/DealerACHList/" + dealerId)
      .then((r) => {
        const bankList = _.map(r.data, (x) => ({
          label: x.secureDisplay,
          value: x.id,
          type: "ach"
        }));
        setDealerBankAccounts(bankList);
        if (selectLast) {
          setSelectedDealerBankAccount(bankList[bankList.length - 1]);
        }
      })
      .catch((e) => console.error(e));
  }

  function disposeTablet() {
    try {
      ClearTabletSurface();
      DeactivateTablet(tabletHandle);
      tabletHandle = null;
    } catch (err) {
      // nothing the user will care about
    }
  }

  function startSignaturePad() {
    // startTablet(onSignatureCapture);
    try {
      tabletHandle =
        StartTablet(canvasRef.current.getContext("2d")) || tabletHandle;
    } catch (err) {
      tabletHandle = null;
    }
    if (tabletHandle == null) {
      console.error(
        "The signature pad could not be detected.  Please ensure that it has been properly installed."
      );
      Alert.error(
        "The signature pad could not be detected.  Please ensure that it has been properly installed."
      );
      closeSignatureCapture();
      disposeTablet();
    }
    setCapturingSignaturePad(true);
  }

  function swipeCreditCardKeydown(event) {
    if (event.which === 13) {
      var ccInfo = new CCSwipeParser(cardSwipe);
      setCardSwipe("");
      if (ccInfo.ErrorMessage) {
        Alert.error(ccInfo.ErrorMessage);
      } else {
        ccInfo.contractId = contractId;
        ccInfo.zip = cardZip;
        api.post("contract/CC", ccInfo).then((r) => {
          if (r.data.success) {
            setCapturingCard(false);
            loadCCList();
          } else {
            Alert.error(r.data.message);
          }
        })
        .catch((e) => console.error(e));
      }
      ccInfo = null;
      return false;
    }
  }

  function saveManualCard() {
    if (!manualCard || manualCard.ErrorMessage) return;
    manualCard.contractId = contractId;
    api.post("contract/CC", manualCard).then((r) => {
      if (r.data.success) {
        setCapturingCardManually(false);
        setManualCard(null);
        loadCCList();
      } else {
        Alert.error(r.data.message);
      }
    }).catch((e) => console.error(e));
  }

  function saveManualDealerCard(data) {
    if (!data) return;
    data.dealerId = dealerId;
    api
      .post("store/DealerCC", data)
      .then((r) => {
        if (r.data.success) {
          setCreditCardOrAch(null);
          setPaymentTransferModalOpen(false);
          // loadDealerCCList(true);
        } else {
          Alert.error(r.data.message);
        }
      })
      .catch((e) => console.error(e));
  }

  const saveACH = async () => {
    let payload = Object.assign({}, achPayment);
    payload.companyId = companyId;
    payload.contractId = contractId;
    if (!validateAch(payload)) return;

    // Pre-validate routing number against the payment gateway before submitting
    try {
      const v = await api.fetch(
        `contract/ValidateRoutingNumber/${payload.routeNumber}/${contractId}`
      );
      if (!v.data.success) {
        setAchValidation((prev) => ({ ...prev, routeNumber: true }));
        setShowAchValidation(true);
        Alert.error("That routing number could not be verified. Please double-check it and try again.");
        return;
      }
    } catch (e) {
      api.catchHandler(e);
      return;
    }

    api.post("contract/ach", payload).then((r) => {
      if (r.data.success) {
        cleanseAchModal();
        loadACHList();
      } else {
        Alert.error(r.data.message);
      }
    }).catch(api.catchHandler);
  };

  function closeSignatureCapture() {
    setCapturingSignature(false);
    setCapturingSignaturePad(false);
    setCapturingSignatureLinkRecipient(false);
    setCapturingContractCodeSignatureLinkRecipient(false);
    setSignatureRequestLinkSent(false);
  }

  function refreshSignatureStatus() {
    api.fetch("contract/GetSignatureDisplay/" + contractId).then((r) => {
      if (r.data.success) {
        setSignatureURL(r.data.message);
        if (r.data.message) {
          closeSignatureCapture();
        }
      } else {
        Alert.error(r.data.message);
      }
    }).catch(api.catchHandler);
  }

  function onSentOutcome(r) {
    if (r.data.success) {
      setSignatureRequestLinkSent(true);
      Alert.success("A restricted link to the mobile contract site has just been sent to " + signatureLinkRecipient);
    } else {
      Alert.error(r.data.message);
    }
  }

  function sendSignatureRequest() {
    if (_.trim(signatureLinkRecipient) === "") {
      Alert.error("You must provide a recipient email address or mobile phone number to send a signature request link.");
      return;
    }
    api.post("contract/SendMobileContractLink", {
      contractId: contractId,
      recipientEmail: signatureLinkRecipient,
      allRelatedDealerUsers: false,
      mobileVisibilityTypeId: constants.MOBILE_VISIBILITY_CONTRACT_SIGNATURE_ID,
    }).then(onSentOutcome).catch((e) => console.error(e));
  }

  function sendSignatureRequestWithCode() {
    if (!_.trim(signatureLinkRecipient)) {
      Alert.error("You must provide a recipient email address or mobile phone number to send a signature request link.");
      return;
    }
    api.post("contract/SendMobileSignatureCapture", {
        contractId: contractId,
        recipientEmail: signatureLinkRecipient,
        allRelatedDealerUsers: false,
        mobileVisibilityTypeId: constants.MOBILE_VISIBILITY_CONTRACT_SIGNATURE_ID,
      }).then(onSentOutcome).catch((e) => console.error(e));
  }

  function signContract() {
    storage.setItem('signingContract', 'true');
    window.open(window.location.origin + "/sign/" + contractPasscode.signatureAccessToken, "_blank");
  }

  function generateContractCode() {
    api.post("contract/GenerateNewContractCode/" + contractId, {
      contractId: contractId,
    }).then((r) => {
      if (r.data.success) {
        setContractPasscode(r.data.message);
        Alert.success("A new contract code has been generated.");
      } else {
        Alert.error(r.data.message);
      }
    })
    .catch((e) => console.error(e));
  }

  function removeSignature() {
    confirmAlert({
      title: "Confirm Deletion",
      message:
        "Are you sure you'd like to permanently and irreversibly delete this customer signature?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            api
              .post("contract/DeleteSignature", {
                contractId: contractId,
                signatureTypeId: constants.SIGNATURE_TYPE_IDS.CUSTOMER_CONTRACT,
              })
              .then((r) => {
                if (r.data.success) {
                  setSignatureURL('');
                } else {
                  Alert.error(r.data.message);
                }
              })
              .catch((e) => console.error(e));
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  function onApplyPayment() {
    if (paymentTypeId === constants.PAYMENT_TYPE_IDS.CREDIT_CARD && !selectedCard) {
      Alert.error("You must first provide a credit card in order to charge a credit card.");
      return;
    }
    if (paymentTypeId === constants.PAYMENT_TYPE_IDS.ACH_DEBIT && !selectedBankAccount) {
      Alert.error("You must first provide a valid bank account.");
      return;
    }
    if (!paymentTransferIntentId && constants.PAYMENT_TYPE_IDS_REQUIRING_TRANSFER.includes(paymentTypeId)) {
      Alert.error("You must first select a payment transfer type.");
      return;
    }
    let ccId = null;
    if (paymentTypeId === constants.PAYMENT_TYPE_IDS.CREDIT_CARD) {
      ccId = selectedCard.value;
    } else if (paymentTypeId === constants.PAYMENT_TYPE_IDS.ACH_DEBIT) {
      ccId = selectedBankAccount.value;
    }
    const amt = paymentAmount;
    setIsPaying(true);
    const payload = {
      contractId: contractId,
      ccId: ccId,
      typeOfPayment: paymentTypeId,
      identifier: paymentIdentifier,
      amount: paymentAmount,
      otherAmountCaption: otherAmountCaption,
      addComment: isCashSale && constants.OPEN_CONTRACT_STATUSES.includes(typeOfContractStatus),
      downPaymentAmount: isRTO ? (parseFloat(initialPaymentAmount) + parseFloat(sideFeePayment)) : null
    };
    api.post("contract/AddManualPayment", payload).then((r) => {
      if (r.data.success) {
        const newList = r.data.message;
        setPaymentIdentifier("");
        setPaymentAmount(0);
        setPaymentList(newList);
        if (paymentTransferIntentId) {
          const addedPayment = _.maxBy(newList, "paidAt");
          onAddTransferPayment(addedPayment.id, paymentTransferIntentId, null, amt);
        }
        setShowTransferModal(false);
        setConfirmTransfer(false);
        setConfirmTransferNow(false);
        // setPendingTransfer(false);
      } else {
        Alert.error(r.data.message);
      }
    })
    .catch((e) => console.error(e))
    .finally(() => setIsPaying(false));
  }

  function onDeletePayment(p) {
    api.post("contract/DeletePayment", { id: p.id }).then((r) => {
      if (r.data.success) {
        setPaymentList(r.data.message);
      } else {
        Alert.error(r.data.message);
      }
    }).catch((e) => console.error(e));
  }

  function getRecurringData() {
    return {
      paymentDayOfMonth: paymentDueDayOfMonth,
      recurringBillingEmail: recurringBillingEmail,
      recurringBillingPhone: recurringBillingPhone || customerPhone1,
      recurringBillingAddress: recurringBillingAddress || billingAddress1,
      recurringBillingCity: recurringBillingCity || billingCity,
      recurringBillingState: recurringBillingState || billingState,
      recurringBillingZip: recurringBillingZip || billingZip,
      creditCardType: creditCardType,
      ccNumber: cardNo,
      ccExpiryMonth: ccExpiryMonth,
      ccExpiryYear: ccExpiryYear,
      ccFullName: ccFullName,
      achRoutingNo: achRoutingNo,
      achAccountNo: achAccountNo,
      achFullName: achFullName,
      achAccountType: constants.BANKING_ACCOUNT_TYPES[0].label,
      achBankName: ''
    }; 
  }

  function onAddTransferPayment(addedPaymentId, intentTypeId = null, selectedTransferCard = null, amount = null) {
    if (!paymentTransferIntentId && !intentTypeId)
      return;
    const transferIntentTypeId = intentTypeId || paymentTransferIntentId;
    const isCard = creditCardOrAch?.value === constants.PAYMENT_TYPE_IDS.CREDIT_CARD;
    const isACH = creditCardOrAch?.value === constants.PAYMENT_TYPE_IDS.ACH_DEBIT;
    let paymentId = null;
    let paymentType = null;

    if (transferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW) {
      if (isCard || selectedDealerCard || selectedTransferCard?.type === "card") {
        paymentType = constants.PAYMENT_TYPE_IDS.CREDIT_CARD;
        paymentId = selectedDealerCard?.value || selectedTransferCard?.value;
      }
      if (isACH || selectedDealerBankAccount || selectedTransferCard?.type === "ach") {
        paymentType = constants.PAYMENT_TYPE_IDS.ACH_DEBIT;
        paymentId = selectedDealerBankAccount?.value || selectedTransferCard?.value;
      }
    } else if (transferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.RETAINED) {
      paymentType = constants.PAYMENT_TYPE_IDS.RETAINED;
    } else if (transferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.MAIL) {
      paymentType = constants.PAYMENT_TYPE_IDS.MAIL;
    } else if (transferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.LATER) {
      paymentType = constants.PAYMENT_TYPE_IDS.LATER;
    }
    setSubmittingTransferPaymentId(addedPaymentId);
    return api.post("contract/AddManualTransferPayment", {
        contractId: contractId,
        dealerId: dealerId,
        transferPaymentId: paymentId,
        typeOfPayment: paymentType,
        amount: paymentAmount || amount,
        otherAmountCaption: otherAmountCaption,
        transferIntentTypeId: transferIntentTypeId,
        contractPaymentId: addedPaymentId
      }).then((r) => {
        if (r.data.success) {
          setPaymentTransferIntentId(null);
          setContractTransferPayments(r.data.message);
          const recentTransferPayment = r.data.message[r.data.message.length - 1];
          if (recentTransferPayment && recentTransferPayment.paymentTransferIntentTypeId == constants.PAYMENT_TRANSFER_TYPE_IDS.NOW) {
            setPendingTransfer(false);
          }
          return { success: true, message: r.data.message };
        } else {
          Alert.error(r.data.message);
          if (transferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW) {
            return onAddTransferPayment(addedPaymentId, constants.PAYMENT_TRANSFER_TYPE_IDS.LATER, null, amount).then((response) => {
              if (response && response.success) {
                Alert.info("The payment transfer could not be completed as 'Now' and has been saved as 'Later' instead.");
                setPendingTransfer(false);
              }
              return response;
            });
          }
          return { success: false, message: r.data.message };
        }
      }).catch((e) => console.error(e))
        .finally(() => setSubmittingTransferPaymentId(null));
  }

  const onAchPaymentChange = (fieldName, fieldValue) => {
    let newPayment = Object.assign({}, achPayment);
    let newValidation = Object.assign({}, achValidation);
    if (fieldName === "accountType") {
      newPayment.accountType = fieldValue.value;
      newPayment.entryClass = fieldValue.entryClass;
    } else if (fieldName === "routeNumber") {
      newPayment.routeNumber = fieldValue;
    } else {
      newPayment[fieldName] = fieldValue;
    }
    validateAch(newPayment);
    setAchPayment(newPayment);
    setAchValidation(newValidation);
  };

  const cleanseAchModal = () => {
    setBankInformation(constants.defaultBank);
    setAchPayment(constants.defaultPayment);
    setAchValidation(constants.defaultAchValidation);
    setCapturingACH(false);
  };

  const validateAch = (vAch) => {
    let invalidAch = Object.assign({}, achValidation);
    let warnings = [];
    if (!vAch.routeNumber.length) {
      warnings.push("Please correct your routing number before continuing.");
      invalidAch.routeNumber = true;
    } else {
      invalidAch.routeNumber = false;
    }
    if (!vAch.name || !vAch.name.length) {
      warnings.push("Please enter the account holders first name.");
      invalidAch.name = true;
    } else {
      invalidAch.name = false;
    }
    if (!vAch.accountType) {
      warnings.push("Please select an account type.");
      invalidAch.accountType = true;
    } else {
      invalidAch.accountType = false;
    }
    if (!vAch.accountNumber) {
      warnings.push("Please enter an account number.");
      invalidAch.accountNumber = true;
    } else {
      invalidAch.accountNumber = false;
    }
    setAchValidation(invalidAch);
    if (Object.keys(invalidAch).some((k) => invalidAch[k] === true)) {
      setShowAchValidation(true);
      return false;
    } else {
      setShowAchValidation(false);
      return true;
    }
  };

  // function findDeliveryCounty() {
  //   if (!deliveryCounty) {
  //     Alert.error("Delivery County Name is required");
  //     return;
  //   }
  //   api.post("Contract/FindTaxRate", {
  //     contractId: contractId,
  //     isInCityLimits: isInCityLimits,
  //     deliveryCounty: deliveryCounty
  //   }).then((res) => {
  //     if (res.data && res.data.success) {
  //       let taxRateString = res.data.message.taxRateValue * 100;
  //       setTaxRate(res.data.message.taxRateValue);
  //       setTaxRateString(taxRateString);
  //     }
  //   })
  //   .catch((error) => {
  //     Alert.error("An error occurred during county lookup");
  //     console.error(error);
  //   });
  // }

  function onShowMobileLink() {
    if (customerPhone1) {
      setSignatureLinkRecipient(ui_helpers.formatPhoneField(customerPhone1));
    }
    setCapturingSignatureLinkRecipient(true);
  }

  function onShowContractCodeMobileLink() {
    if (customerPhone1) {
      setSignatureLinkRecipient(ui_helpers.formatPhoneField(customerPhone1));
    }
    setCapturingContractCodeSignatureLinkRecipient(true);
  }

  function onDeleteSelectedCC() {
    if (!selectedCard) return;
    const deleteCCId = selectedCard.value;
    confirmAlert({
      title: "Confirm Credit Card Delete",
      message: "Are you sure you'd like to permanently and irreversibly delete this credit card and ALL RELATED PAYMENTS?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            api.post('contract/DeleteCC', {
              contractId: contractId,
              accountId: deleteCCId
            }).then(r => {
              if (r.data.success) {
                setPaymentList(r.data.message);
                loadCCList();
              } else {
                Alert.error(r.data.message);
              }
            }).catch((e) => console.error(e));    
          }
        },
        {
          label: "No"
        }
      ]
    });
  }

  function onDownloadAttachment(contractId, key = null, onComplete = null) {
    const pdfWindow = window.open();
    // null document key means download all
    api.downloadAndOpenFile("contract/DownloadContractDocument",
        { referenceId: contractId, documentKey: key },
        pdfWindow,
        (e) => {
          console.error(e);
          // Alert.error("There was an error downloading the attachment");
          if (pdfWindow) {
            pdfWindow.close();
          }
        },
        constants.MIME_PDF,
        onComplete
    );
  }

  function onDeleteSelectedACH() {
    if (!selectedBankAccount) return;
    const deleteACHId = selectedBankAccount.value;
    confirmAlert({
      title: "Confirm ACH Delete",
      message: "Are you sure you'd like to permanently and irreversibly delete this ACH bank account and ALL RELATED PAYMENTS?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            api.post('contract/DeleteACH', {
              contractId: contractId,
              accountId: deleteACHId
            }).then(r => {
              if (r.data.success) {
                setPaymentList(r.data.message);
                loadACHList();
              } else {
                Alert.error(r.data.message);
              }
            }).catch((e) => console.error(e));    
          }
        },
        {
          label: "No"
        }
      ]
    });
  }

  const paymentsWithTransfers = _.map(paymentList, (payment) => {
    const transfers = _.filter(contractTransferPayments, (t) => t.contractPaymentId === payment.id);
    const transfersWithTransferredFlag = transfers.map((transfer) => {
      if (transfer.paymentTransferIntentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.LATER) {
        const hasBeenTransferred = contractTransferPayments.some(
          (t) => t.transferPaymentId === transfer.id
        );
        return {
          ...transfer,
          isTransferred: hasBeenTransferred,
        };
      }
      return transfer;
    });

    return {
      ...payment,
      transfers: transfersWithTransferredFlag,
    };
  });

  const setTransferPaymentReceived = (transferPayment, isReceived) => {
    if (!transferPayment) return;
    api
      .post(`contract/SetTransferPaymentReceived/${transferPayment.id}`, isReceived)
      .then((response) => {
        setOpenTransferPopoverId(null);
        reloadPaymentsAndTransfers();
      })
      .catch((error) => {
        console.error("Error toggling transfer payment mail status:", error);
      });
  };

  function reloadPaymentsAndTransfers() {
    if (!contractId) return;
    api
      .fetch(`contract/GetContractPaymentsAndTransfers/${contractId}`)
      .then((response) => {
        if (response.data.success) {
          setPaymentList(response.data.message.payments);
          setContractTransferPayments(response.data.message.paymentTransfers);
        }
      })
      .catch((error) => {
        console.error("Error reloading payments and transfers:", error);
      });
  }


  function onUpdateTransferType(transferPaymentId, newTypeId) {
    if (!transferPaymentId) return;
    api
      .post(`contract/UpdateTransferIntentType/${transferPaymentId}`, newTypeId)
      .then((response) => {
        if (response.data.success) {
          reloadPaymentsAndTransfers();
        } else {
          Alert.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error updating transfer payment type:", error);
      });
  }

  function checkIfTransferModalShouldOpen(paymentTypeId, intentTypeId) {
    if (constants.PAYMENT_TYPE_IDS_REQUIRING_TRANSFER.includes(paymentTypeId) &&
        intentTypeId && intentTypeId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW) {
      setShowTransferModal(true);
    } else {
      if (showTransferModal) setShowTransferModal(false);
      onApplyPayment();
    }
  }

  return (
    <Row>
      <Col xs="4">
        <Form className="mt-2">
          <Row>
            <Col>
              <div className="d-grid mb-3">
                {signatureURL ? (
                  <Row>
                    <Col xs="6">
                      <Button
                        block
                        color="warning"
                        className="text-light"
                        onClick={() => setCapturingSignature(true)}
                      >
                        <FontAwesomeIcon
                          icon="hand-point-right"
                          className="me-2"
                        />
                        Replace Signature
                      </Button>
                    </Col>
                    <Col xs="6">
                      <Button
                        block
                        color="danger"
                        className="text-light"
                        onClick={removeSignature}
                      >
                        <FontAwesomeIcon icon="times" className="me-2" />
                        Remove Signature
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  <>
                    {sessionStarted && completedSignatures?.length < signatureLocations?.length && !contractFinalized ? (
                      <>
                        <h5 className="text-primary">
                          The customer is reviewing the contract on another device.
                        </h5>
                        <strong>
                          This contract document requires {signatureLocations?.length} signatures.
                        </strong>
                        <ul className="list-group">
                          {signatureLocations?.map((sl, i) => (
                            <li key={sl.id} className="list-group-item">
                              <FontAwesomeIcon
                                icon={
                                  completedSignatures.includes(sl.id)
                                    ? "check"
                                    : "times"
                                }
                                className={
                                  completedSignatures.includes(sl.id)
                                    ? "text-success me-2"
                                    : "text-danger me-2"
                                }
                              />
                              Signature {i + 1}: Page {sl.pageIndex + 1}
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                    {sessionStarted && completedSignatures?.length === signatureLocations?.length && !contractFinalized ? (
                      <h5 className="text-primary">
                        Waiting for customer to finalize signatures.
                      </h5>
                    ) : null}
                    {sessionStarted && completedSignatures?.length === signatureLocations?.length && contractFinalized ? (
                      <h4 className="text-success fw-bold">
                        Customer has signed the contract.
                      </h4>
                    ) : null}
                    {/* {!sessionStarted ? ( */}
                      <Button
                        color="primary"
                        onClick={() => setCapturingSignature(true)}
                      >
                        <FontAwesomeIcon
                          icon="hand-point-right"
                          className="me-2"
                        />
                        Capture Signature
                      </Button>
                    {/* ) : null} */}
                  </>
                )}
              </div>
              {isRTO ? (
                <Fragment>
                  <div className="mb-1">
                    <Row>
                      <Col xs="6" className="pt-1">
                        <Label>
                          <div>Initial Payment</div>
                          {sideFeePayment
                            ? (<div style={{fontStyle: "italic"}}> including {ui_helpers.formatCurrency(sideFeePayment)} side fees</div>)
                            : null
                          }
                          {screenWarnings.initialPaymentAmount ? (
                            <span id="initialPaymentError">{ui_helpers.redExclamation()}</span>
                          ) : null}
                          {screenWarnings.initialPaymentAmount && (
                            <UncontrolledTooltip
                              target="initialPaymentError"
                              placement="top"
                            >
                              {screenWarnings.initialPaymentAmount}
                            </UncontrolledTooltip>
                          )}
                        </Label>
                      </Col>
                      <Col xs="6">
                        <Input
                          type="text"
                          readOnly
                          disabled
                          title={
                            screenWarnings.initialPaymentAmount
                              ? screenWarnings.initialPaymentAmount
                              : null
                          }
                          className={classnames(
                            {
                              invalid: screenWarnings.initialPaymentAmount
                                ? true
                                : false,
                            },
                            "text-end form-control"
                          )}
                          value={ui_helpers.formatCurrency(parseFloat(initialPaymentAmount) + parseFloat(sideFeePayment))}
                        />
                      </Col>
                    </Row>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <Row className="mb-1">
                    <Col xs="6" className="pt-1">
                      <Label>Unit Price</Label>
                    </Col>
                    <Col xs="6">
                      <DebounceInput
                        type="text"
                        maxLength="15"
                        minLength="2"
                        title={
                          screenWarnings.unitPrice
                            ? screenWarnings.unitPrice
                            : null
                        }
                        className={classnames(
                          { invalid: screenWarnings.unitPrice ? true : false },
                          "text-end form-control"
                        )}
                        value={
                          unitPriceDisabled
                            ? ui_helpers.formatCurrency(unitPrice)
                            : unitPrice
                        }
                        disabled={unitPriceDisabled}
                        debounceTimeout={300}
                        onChange={(e) => setUnitPrice(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <PriceAdjustmentEditor
                    addPriceAdjustment={props.addPriceAdjustment}
                    deletePriceAdjustment={props.deletePriceAdjustment}
                  />
                  <Row className="mb-1">
                    <Col xs="6">
                      <Label>Tax Rate {ui_helpers.requiredStar()}</Label>
                    </Col>
                    <Col xs="6">
                      <InputGroup>
                        <DebounceInput
                          type="text"
                          maxLength="15"
                          minLength="1"
                          value={isTaxExempt ? 0.0 : taxRateString}
                          className="text-end form-control form-control-sm"
                          style={{ width: "80px", float: "left" }}
                          readOnly={isTaxExempt}
                          debounceTimeout={900}
                          onChange={(e) => setTaxRateString(e.target.value)}
                        />
                        <InputGroupText>%</InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col xs="6"/>
                    <Col xs="3" className={'d-flex justify-content-end'}>
                      <ToggleButton value={isTaxExempt} inactiveLabel={''} activeLabel={''} onToggle={(val) => setIsTaxExempt(!val)} />
                    </Col>
                    <Col xs={"3"}>
                      <Label>Tax Exempt</Label>
                    </Col>
                  </Row>
                  {isTaxExempt  ?
                      ( <Row>
                      <Row className="d-flex">
                        <Label>Tax Exemption Form {ui_helpers.requiredStar()}</Label>
                      </Row>
                      <Row>
                        {taxExemptionForm
                            ? <>
                              {taxExemptionForm.file ? <span>{taxExemptionForm.file?.name ?? "Tax Exemption Form"}</span> : null}
                              {taxExemptionForm.name ?
                                  <Button
                                      color="link"
                                      className="download-link text-start"
                                      onClick={() =>
                                          onDownloadAttachment(taxExemptionForm.contractId, taxExemptionForm.key)
                                      }
                                  >
                                    {taxExemptionForm.name}
                                  </Button> : null}</>
                            : <input type="file" id="myFile"
                                     name="taxExemptionForm"
                                     accept={constants.MIME_PDF}
                                     onChange={(e) => onUploadTaxExemptionForm(e.target.files[0])}/>}
                      </Row>
                      </Row>) : null}
                  <Row className="mb-1">
                    <Col xs="6">
                      <Label>Tax Amount $</Label>
                    </Col>
                    <Col xs="6">
                      <DebounceInput
                        type="text"
                        maxLength="25"
                        minLength="1"
                        value={taxAmount}
                        className="text-end form-control form-control-sm"
                        readOnly={isTaxExempt}
                        debounceTimeout={300}
                        onChange={(e) => setTaxAmount(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col xs="6">
                      <Label>Delivery County {ui_helpers.requiredStar()}</Label>
                    </Col>
                    <Col xs="6">
                      <Row>
                        <Col>
                          <Input
                            type="text"
                            bsSize="sm"
                            title={
                              screenWarnings.deliveryCounty
                                ? screenWarnings.deliveryCounty
                                : null
                            }
                            className={classnames(
                              {
                                invalid: screenWarnings.deliveryCounty
                                  ? true
                                  : false,
                              },
                              "text-end form-control"
                            )}
                            value={deliveryCounty}
                            onChange={(e) => setDeliveryCounty(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col xs="6" className="pt-2">
                      <Label>Total</Label>
                    </Col>
                    <Col xs="6">
                      <Input
                        type="text"
                        className="text-end"
                        readOnly
                        disabled
                        value={ui_helpers.formatCurrency(subtotal)}
                      />
                    </Col>
                  </Row>
                </Fragment>
              )}
              <div className="mb-1">
                <Row>
                  <Col xs="6" className="pt-1">
                    <Label>
                      {isRTO ? "" : "Down "}
                      Payment Type {ui_helpers.requiredStar()}
                    </Label>
                  </Col>
                  <Col
                    xs="6"
                    className="form-control-sm"
                    style={{ padding: "0 12px" }}
                  >
                    <Select
                      options={_.reject(paymentTypes, (x) => x.hidden)}
                      value={_.find(constants.PAYMENT_TYPES, (o) => o.value === paymentTypeId)}
                      onChange={({ value: newPaymentTypeId }) => onChangePaymentType(newPaymentTypeId)}
                    />
                  </Col>
                </Row>
              </div>
              {paymentTypeId === constants.PAYMENT_TYPE_IDS.CREDIT_CARD ? (
                <div className="mb-1">
                  <Row>
                    <Col xs="6" className="pt-1">
                      <Label>Cards</Label>
                    </Col>
                    <Col
                      xs="6"
                      className="form-control-sm"
                      style={{ padding: "0 12px" }}
                    >
                      <InputGroup size="sm">
                        <div style={{width: "70%"}}>
                          <Select
                            options={cards}
                            value={selectedCard}
                            onChange={(x) => setSelectedCard(x)}
                          />
                        </div>
                        <Button
                          color="dark"
                          className="text-light"
                          title="Add Credit Card By Swipe"
                          style={{ zIndex: 0 }}
                          onClick={() => setCapturingCard(true)}
                        >
                          <FontAwesomeIcon icon="credit-card" />
                        </Button>
                        {isSysAdmin && selectedCard
                          ? (<Button className="text-light" color="danger" title="Delete Credit Card" style={{zIndex: 0}} onClick={onDeleteSelectedCC}>
                              <FontAwesomeIcon icon="times-circle" />
                            </Button>)
                          : null
                        }
                      </InputGroup>
                    </Col>
                  </Row>
                </div>
              ) : null}
              {paymentTypeId === constants.PAYMENT_TYPE_IDS.ACH_DEBIT ? (
                <div className="mb-1">
                  <Row>
                    <Col xs="6" className="pt-1">
                      <Label>Bank Account</Label>
                    </Col>
                    <Col
                      xs="6"
                      className="form-control-sm"
                      style={{ padding: "0 12px" }}
                    >
                      <InputGroup size="sm">
                        <div style={{width: "85%"}}>
                          <Select
                            options={bankAccounts}
                            value={selectedBankAccount}
                            onChange={(x) => setSelectedBankAccount(x)}
                          />
                        </div>
                        {isSysAdmin && selectedBankAccount
                          ? (<Button className="text-light" color="danger" title="Delete ACH" style={{zIndex: 0}} onClick={onDeleteSelectedACH}>
                              <FontAwesomeIcon icon="times-circle" />
                            </Button>)
                          : null
                        }
                      </InputGroup>
                    </Col>
                  </Row>
                </div>
              ) : null}
              {paymentTypeId === constants.PAYMENT_TYPE_IDS.CHECK || paymentTypeId === constants.PAYMENT_TYPE_IDS.MONEY_ORDER ? (
                <div className="mb-1">
                  <Row>
                    <Col xs="6" className="pt-1">
                      <Label>
                        Check Number {ui_helpers.requiredStar()}
                      </Label>
                    </Col>
                    <Col xs="6">
                      <DebounceInput
                        type="text"
                        maxLength="15"
                        minLength="1"
                        className="form-control form-control-sm"
                        value={paymentIdentifier}
                        debounceTimeout={300}
                        onChange={(e) => setPaymentIdentifier(e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>
              ) : null}
              <div className="mb-1">
                <Row>
                  <Col xs="6" className="pt-1">
                    <Label>
                      {isRTO
                        ? ""
                        : "Down "}
                      Payment Amount {ui_helpers.requiredStar()}
                    </Label>
                  </Col>
                  <Col xs="6">
                    <DebounceInput
                      type="text"
                      maxLength="15"
                      minLength="2"
                      className="text-end form-control form-control-sm"
                      value={paymentAmount}
                      debounceTimeout={300}
                      onChange={(e) => setPaymentAmount(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
              {isRTO ? (
                <Row className="mb-1">
                  <Col xs="6" className="pt-1">
                    <div
                      className="mb-1"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!enableRecurringPayments) {
                          setCapturingRecurring(true);
                        }
                        setEnableRecurringPayments(!enableRecurringPayments);
                      }}
                    >
                      <Input
                        type="checkbox"
                        checked={enableRecurringPayments}
                        onChange={(e) => {
                          e.stopPropagation();
                          if (!enableRecurringPayments) {
                            setCapturingRecurring(true);
                          }
                          setEnableRecurringPayments(!enableRecurringPayments);
                        }}
                      />{" "}
                      Enable Recurring Payments
                    </div>
                  </Col>
                  <Col xs="6">
                    {enableRecurringPayments ? (
                      <Button
                        block
                        color="warning"
                        className="text-light"
                        onClick={() => setCapturingRecurring(true)}
                      >
                        Set Recurring Payment Information
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              ) : null}
              {paymentTypeId != null && constants.PAYMENT_TYPE_IDS_REQUIRING_TRANSFER.includes(paymentTypeId) ? (
                <Row className="mb-2">
                  <Col xs="6" className="pt-2">
                    <Label>
                      Payment Transfer Type {ui_helpers.requiredStar()}{" "}
                      {screenWarnings.paymentTransferIntentId ? (
                        <span id="paymentTransferTypeError">{ui_helpers.redExclamation()}</span>
                      ) : null}
                      {screenWarnings.paymentTransferIntentId && (
                        <UncontrolledTooltip target="paymentTransferTypeError" placement="top">
                          {screenWarnings.paymentTransferIntentId}
                        </UncontrolledTooltip>
                      )}
                    </Label>
                  </Col>
                  <Col xs="6" className="form-control-sm" style={{ padding: "0 12px" }}>
                    <Select
                      title={
                        screenWarnings.paymentTransferIntentId
                          ? screenWarnings.paymentTransferIntentId
                          : null
                      }
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: screenWarnings.paymentTransferIntentId
                            ? "#ffcccc"
                            : provided.backgroundColor,
                        }),
                      }}
                      options={paymentTransferOptions}
                      value={_.find(paymentTransferOptions, (o) => o.value === paymentTransferIntentId) ?? null}
                      onChange={({ value: newId }) => {
                        setPaymentTransferIntentId(newId);
                        if (newId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW) {
                          setPendingTransfer(true);
                        }
                        if (pendingTransfer && newId !== constants.PAYMENT_TRANSFER_TYPE_IDS.NOW) {
                          setPendingTransfer(false);
                          setSelectedDealerCard(null);
                          setSelectedDealerBankAccount(null);
                        }
                      }}
                    />
                  </Col>
                </Row>
              ) : null}
              {paymentTransferIntentId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW ? (
                <Row className="mb-2">
                  <Col xs="6" className="pt-1">
                    <Label>Payment Method</Label>
                  </Col>
                  <Col xs="6" className="form-control-sm" style={{ padding: "0 12px" }}>
                    <InputGroup size="sm">
                      <div style={{ width: "70%" }}>
                        <Select
                          options={
                            // agreementNumber !== constants.CASH_SALE
                            //   ? [
                            //       ...dealerCards.map(card => ({ ...card, label: `Card: ${card.label}` })),
                            //       ...dealerBankAccounts.map(ach => ({ ...ach, label: `ACH: ${ach.label}` })),
                            //       isSysAdmin ? { label: "➕ Add New...", value: "add-new", type: "add" } : { label: "Please call the RTO Office to add a new transfer method" }
                            //     ] :
                            [...dealerBankAccounts,
                              isSysAdmin ?
                              {
                                label: "➕ Add New...",
                                value: "add-new",
                                type: "add"
                              } : {
                                label: "Please call the RTO Office to add a new transfer method",
                              }
                            ]
                          }
                          value={selectedDealerCard || selectedDealerBankAccount}
                          onChange={(option) => {
                            if (option.type === "card") {
                              setSelectedDealerCard(option);
                              setSelectedDealerBankAccount(null);
                            } else if (option.type === "ach") {
                              setSelectedDealerBankAccount(option);
                              setSelectedDealerCard(null);
                            } else if (option.type === "add") {
                              setPaymentTransferModalOpen(true);
                              setCreditCardOrAch(null);
                              setSelectedDealerCard(null);
                              setSelectedDealerBankAccount(null);
                            }
                          }}
                        />
                      </div>
                      {isSysAdmin ? (
                        <Button
                          color="dark"
                          className="text-light"
                          title="Add New Payment Method"
                          style={{ zIndex: 0 }}
                          onClick={() => setPaymentTransferModalOpen(true)}
                        >
                          <FontAwesomeIcon icon="credit-card" />
                        </Button>
                      ) : null}
                      {isSysAdmin && selectedCard ? (
                        <Button
                          className="text-light"
                          color="danger"
                          title="Delete Credit Card"
                          style={{ zIndex: 0 }}
                          onClick={onDeleteSelectedCC}
                        >
                          <FontAwesomeIcon icon="times-circle" />
                        </Button>
                      ) : null}
                    </InputGroup>
                  </Col>
                </Row>
              ) : null}
              {isPaying ? (
                <div className={"d-flex justify-content-center align-items-center"}>
                  <Loading messageText="Processing Payment..." />
                </div>
              ) : (
                <div className="d-grid">
                  <Button
                    color="success"
                    className="text-light"
                    onClick={() => checkIfTransferModalShouldOpen(paymentTypeId, paymentTransferIntentId)}
                    disabled={
                    (constants.PAYMENT_TYPE_IDS_REQUIRING_TRANSFER.includes(paymentTypeId)
                    && !paymentTransferIntentId) || (
                      paymentTransferIntentId === constants.PAYMENT_TRANSFER_TYPE_IDS.NOW &&
                      !selectedDealerCard && !selectedDealerBankAccount
                    )
                  }
                  >
                    <FontAwesomeIcon icon="plus-circle" className="me-2" />
                    Apply Payment
                  </Button>
                </div>
              )}
            </Col>
          </Row>
          {isRTO ? (
            <Row className="my-3">
              <Col>
                <Table bordered className="mb-0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Paid / Processed</th>
                      <th>Amount</th>
                      <th>Transfers</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {paymentsWithTransfers && paymentsWithTransfers.length ? (
                      <Fragment>
                        {_.map(paymentsWithTransfers, (x) => {
                          const pt = _.find(constants.PAYMENT_TYPES, (pt) => pt.value === x.typeOfPayment);
                          return (
                          <tr key={`${x.id}-${x?.paymentTransferIntentId}`}>
                            <td>
                              {pt ? pt.label : ""}
                              <br />
                              {x.identifier}
                            </td>
                            <td>
                              <div>Paid {date_helpers.dateTimeFormat(x.paidAt)}</div>
                              {x.processedAt
                                ? (<div className="text-muted fst-italic">Processed {date_helpers.dateTimeFormat(x.processedAt)}</div>)
                                : null
                              }
                            </td>
                            <td className="text-end">{ui_helpers.formatCurrency(x.amount)}</td>
                            <TransferPopoverTD
                              paymentId={x.id}
                              transfers={x.transfers}
                              openTransferPopoverId={openTransferPopoverId}
                              agreementNumber={agreementNumber}
                              // dealerCards={dealerCards}
                              dealerBankAccounts={dealerBankAccounts}
                              setTransferPaymentReceived={setTransferPaymentReceived}
                              openTransferNowDropdownId={openTransferNowDropdownId}
                              setOpenTransferNowDropdownId={setOpenTransferNowDropdownId}
                              setOpenTransferPopoverId={setOpenTransferPopoverId}
                              setSelectedDealerCard={setSelectedDealerCard}
                              onAddTransferPayment={onAddTransferPayment}
                              setSelectedDealerBankAccount={setSelectedDealerBankAccount}
                              setPaymentTransferModalOpen={setPaymentTransferModalOpen}
                              setCreditCardOrAch={setCreditCardOrAch}
                              toggleTransferPopover={toggleTransferPopover}
                              changeTransferType={changeTransferType}
                              setChangeTransferType={setChangeTransferType}
                              isSysAdmin={isSysAdmin}
                              canSetRetained={canSetRetained}
                              isCashSale={isCashSale}
                              onUpdateTransferType={onUpdateTransferType}
                              submittingTransferPaymentId={submittingTransferPaymentId}
                            />
                            <td>
                              {!x.processedAt || isSysAdmin || isCompanyAdmin
                                ? (<Button
                                    className="text-light xs float-end"
                                    color="danger"
                                    onClick={() => onDeletePayment(x)}
                                  >
                                    <FontAwesomeIcon icon="times-circle" />
                                  </Button>)
                                : null
                              }
                            </td>
                          </tr>
                        )})}
                        <tr className="tr-bold active">
                          <td colSpan="3" className="pt-1 text-end">
                            <label style={{ fontWeight: "bold" }}>
                              Payments
                            </label>
                          </td>
                          <td
                            className="text-end"
                            style={{
                              borderTop: "1px #000 solid",
                              borderBottom: "3px #000 double",
                            }}
                          >
                            {ui_helpers.formatCurrency(
                              paymentList.length
                                ? _.sumBy(paymentList, (x) => x.amount)
                                : 0.0
                            )}
                          </td>
                        </tr>
                        {isRTO ? null : (
                          <tr>
                            <td colSpan="3" className="pt-1 text-end">
                              <label
                                style={{
                                  backgroundColor: "Yellow",
                                  fontWeight: "bold",
                                }}
                              >
                                Balance Due
                              </label>
                            </td>
                            <td
                              className="text-end"
                              style={{ fontWeight: "bold" }}
                            >
                              {ui_helpers.formatCurrency(
                                balanceDue
                              )}
                            </td>
                          </tr>
                        )}
                      </Fragment>
                    ) : (
                      <tr>
                        <td colSpan="5">No payments have yet been recorded.</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          ) : null}
        </Form>
      </Col>
      <Col xs="8">
        {signatureURL ? (
          <div>
            <img
              style={{ width: "250px", float: "left" }}
              src={signatureURL}
              alt="Customer Signature"
            />
          </div>
        ) : null}
        {isRTO ? (
          <div
            style={{
              backgroundColor: "#E5E5FF",
              border: "solid 1px #999",
              padding: "10px",
              marginTop: "8px",
              clear: "both",
            }}
          >
            <h4>Recurring Payments Will Make Your Life Easier</h4>
            <ul>
              <li>It’s convenient, saving you time and postage</li>
              <li>
                Your payment is always on time, even if you forget about it or
                are traveling
              </li>
              <li>Eliminates late fees, saving you money</li>
            </ul>
            <h4>Here’s How Recurring Payments Work</h4>
            <ul>
              <li>You authorize monthly charges to your card.</li>
              <li>
                You will be charged each billing period for the total amount due
                for that period.
              </li>
              <li>
                You will be emailed a receipt and the charge will appear on your
                credit card or bank statement.
              </li>
            </ul>
          </div>
        ) : (
          <Row className="my-3">
            <Col>
              <Table bordered className="mb-0">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Number</th>
                    <th>Paid/Processed</th>
                    <th>Amount</th>
                    <th>Transfers</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {paymentsWithTransfers && paymentsWithTransfers.length ? (
                    <Fragment>
                      {_.map(paymentsWithTransfers, (x) => {
                        const pt = _.find(constants.PAYMENT_TYPES, (pt) => pt.value === x.typeOfPayment);
                        return (
                        <tr key={x.id}>
                          <td>{pt ? pt.label : ""}</td>
                          <td>{x.identifier}</td>
                          <td>
                            {date_helpers.dateTimeFormat(x.paidAt)}{" "}
                            {x.processedAt ? ui_helpers.greenCheck() : null}
                          </td>
                          <td className="text-end">
                            {ui_helpers.formatCurrency(x.amount)}
                          </td>
                          <TransferPopoverTD
                            paymentId={x.id}
                            transfers={x.transfers}
                            openTransferPopoverId={openTransferPopoverId}
                            agreementNumber={agreementNumber}
                            // dealerCards={dealerCards}
                            dealerBankAccounts={dealerBankAccounts}
                            setTransferPaymentReceived={setTransferPaymentReceived}
                            openTransferNowDropdownId={openTransferNowDropdownId}
                            setOpenTransferNowDropdownId={setOpenTransferNowDropdownId}
                            setOpenTransferPopoverId={setOpenTransferPopoverId}
                            setSelectedDealerCard={setSelectedDealerCard}
                            onAddTransferPayment={onAddTransferPayment}
                            setSelectedDealerBankAccount={setSelectedDealerBankAccount}
                            setPaymentTransferModalOpen={setPaymentTransferModalOpen}
                            setCreditCardOrAch={setCreditCardOrAch}
                            toggleTransferPopover={toggleTransferPopover}
                            changeTransferType={changeTransferType}
                            setChangeTransferType={setChangeTransferType}
                            isSysAdmin={isSysAdmin}
                            canSetRetained={canSetRetained}
                            isCashSale={isCashSale}
                            onUpdateTransferType={onUpdateTransferType}
                            submittingTransferPaymentId={submittingTransferPaymentId}
                          />
                          <td>
                            {x.processedAt && !isSysAdmin && !isCompanyAdmin
                              ? null
                              : (<Button
                                  className="text-light xs float-end"
                                  color="danger"
                                  onClick={() => onDeletePayment(x)}
                                >
                                  <FontAwesomeIcon icon="times-circle" />
                                </Button>)
                            }
                          </td>
                        </tr>
                      )})}
                      <tr className="tr-bold active">
                        <td colSpan="3" className="pt-1 text-end">
                          <label style={{ fontWeight: "bold" }}>Payments</label>
                        </td>
                        <td
                          className="text-end"
                          style={{
                            borderTop: "1px #000 solid",
                            borderBottom: "3px #000 double",
                          }}
                        >
                          {ui_helpers.formatCurrency(
                            paymentList.length
                              ? _.sumBy(paymentList, (x) => x.amount)
                              : 0.0
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3" className="pt-1 text-end">
                          <label
                            style={{
                              backgroundColor: "Yellow",
                              fontWeight: "bold",
                            }}
                          >
                            Balance Due
                          </label>
                        </td>
                        <td className="text-end" style={{ fontWeight: "bold" }}>
                          {ui_helpers.formatCurrency(balanceDue)}
                        </td>
                      </tr>
                    </Fragment>
                  ) : (
                    <tr>
                      <td colSpan="5">No payments have yet been recorded.</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}
        {creditCardFeePercentage && !isRTO ? (
          <table className="mb-0 mt-3 ms-2">
            <tbody>
              <tr>
                <td colSpan="5" style={{fontWeight: "bold", borderStyle: "none"}}>
                  Note that a {creditCardFeePercentage}% credit card fee will be added automatically to any credit card transactions
                </td>
              </tr>
            </tbody>
          </table>
        ) : null}
      </Col>
      {capturingRecurring ? (
        <RecurringPaymentModal
          recurringData={getRecurringData()}
          onCancel={() => setCapturingRecurring(false)}
          onSetRecurringData={onSetRecurringData}
        />
      ) : null}
      {capturingSignature ? (
        <Modal isOpen={true} centered size="md">
          <ModalHeader>Capture Signature</ModalHeader>
          <ModalBody>
            {capturingSignaturePad || capturingSignatureLinkRecipient || capturingContractCodeSignatureLinkRecipient ? null : (
              <Row>
                <Col xs="6">
                {/* <Button size="lg" color="primary" onClick={startSignaturePad}>
                    Click to Sign
                </Button> */}
                {/* <Button onClick={sendSignatureRequestWithCode}>
                    Send using Contract Code
                  </Button> */}
                <Button
                  onClick={() => onShowContractCodeMobileLink()}
                  color="warning"
                  style={{width: "100%", fontWeight: "bold", fontSize: "0.9rem", marginTop: "10px"}}
                  >
                  Send Mobile Link - New
                </Button>
                <Button
                  onClick={() => onShowMobileLink()}
                  color="dark"
                  style={{width: "100%", fontWeight: "bold", fontSize: "0.9rem", marginTop: "10px" }}
                >
                  Send Mobile Link - Old
                </Button>
                {contractPasscode == null || contractPasscode?.deactivatedAt != null || (date_helpers.dateTimeFormat(moment()) > date_helpers.dateTimeFormat(contractPasscode?.expiresAt)) ? (
                  <Button
                    size="lg"
                    color="primary"
                    onClick={generateContractCode}
                    style={{width: "100%", 
                      fontSize: "0.9rem", 
                      fontWeight: "bold", 
                      marginTop: "10px", 
                    }}
                  >
                    Generate Contract Code
                  </Button>
                  ) : (
                    <Button
                    onClick={generateContractCode}
                    style={{width: "100%", backgroundColor: "rgb(69, 137, 196)", fontSize: "0.9rem", fontWeight: "bold", marginTop: "10px", borderColor: "rgb(69, 137, 196)", }}
                    disabled
                  >
                    Generate Contract Code
                  </Button>
                )}
                </Col>
                <Col xs="6">
                {contractPasscode != null && contractPasscode?.deactivatedAt == null && (date_helpers.dateTimeFormat(moment()) < date_helpers.dateTimeFormat(contractPasscode?.expiresAt)) ? (
                  <div style={{height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                  <div style={{textAlign: "center"}}>
                    Contract Code:
                  <span style={{fontWeight: "bold", fontSize: 23, letterSpacing: "0.2em", display: "block"}}>
                    {contractPasscode?.signatureAccessToken}
                  </span>
                  </div>
                  <Button
                    size="md"
                    color="primary"
                    style={{width: "100%", fontSize: "0.9rem", fontWeight: "bold"}}
                    onClick={signContract}
                  >
                    Click to View Contract
                  </Button>
                  </div>
                ) : (
                <div style={{alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", color: "gray"}}>
                 No valid contract code set.
                 <span style={{display: "block", fontWeight: "bold"}}>Please generate a new one.</span>
                </div>)}
                </Col>
              </Row>
            )}

            {capturingSignatureLinkRecipient ? (
              <Col>
              <Row>
                <Col>
                  <Input
                    type="text"
                    className="mt-1"
                    value={signatureLinkRecipient}
                    maxLength="150"
                    style={{ width: "200px" }}
                    placeholder="Recipient Mobile #"
                    onChange={(e) => setSignatureLinkRecipient(e.target.value)}
                  />
                </Col>
                <Col>
                  <ButtonGroup className="float-end">
                    <Button color="primary" onClick={sendSignatureRequest}>
                      Send Now
                    </Button>
                    {signatureRequestLinkSent ? (
                      <Button color="dark" onClick={refreshSignatureStatus}>
                        Refresh
                      </Button>
                    ) : null}
                  </ButtonGroup>
                </Col>
              </Row>
            </Col>
            ) : null}

            {capturingContractCodeSignatureLinkRecipient ? (
              <Col>
              <Row>
                <Col>
                  <Input
                    type="text"
                    className="mt-1"
                    value={signatureLinkRecipient}
                    maxLength="150"
                    style={{ width: "200px" }}
                    placeholder="Recipient Mobile #"
                    onChange={(e) => setSignatureLinkRecipient(e.target.value)}
                  />
                </Col>
                <Col>
                  <ButtonGroup className="float-end">
                    <Button color="primary" onClick={sendSignatureRequestWithCode}>
                      Send Now
                    </Button>
                    {signatureRequestLinkSent ? (
                      <Button color="dark" onClick={refreshSignatureStatus}>
                        Refresh
                      </Button>
                    ) : null}
                  </ButtonGroup>
                </Col>
              </Row>
            {contractPasscode && contractPasscode?.deactivatedAt == null 
            && (date_helpers.dateTimeFormat(moment()) < date_helpers.dateTimeFormat(contractPasscode?.expiresAt)) && (
              <Row className="mt-3">
                <Col>
                  Contract Code:{" "}
                  <span style={{fontWeight: "bold", fontSize: 20, letterSpacing: "0.2em"}}>
                    {contractPasscode?.signatureAccessToken}
                  </span>
                </Col>
              </Row>
            )}
            </Col>
            ) : null}
            {capturingSignaturePad ? (
              <div
                id="tablet-container"
                style="width: 500px; height: 100px; display: none;"
              >
                <canvas
                  ref={canvasRef}
                  height="100"
                  width="500"
                  name="signatureCanvas"
                  id="signatureCanvas"
                ></canvas>
              </div>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col className="d-flex flex-row justify-content-end">
{/*             <Col className="d-flex justify-content-end">
                  <Button color="secondary" onClick={closeSignatureCapture}>
                    Cancel
                  </Button>
                </Col>
                <Col className="ms-1 d-flex justify-content-end">
                  <Button
                    color="primary"
                    className="float-end"
                    disabled={true}
                    onClick={() => saveSignature()}
                  >
                    Save
                  </Button>
                </Col>
 */}
                <Col className="d-flex justify-content-end">
                  <Button
                    color="secondary"
                    className="float-end"
                    onClick={closeSignatureCapture}
                  >
                    Done
                  </Button>
                </Col>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      ) : null}
      {paymentTransferModalOpen ? (
        <PaymentInformationModal
          onCancel={() => {
            setPaymentTransferModalOpen(false);
            setCreditCardOrAch(null);
          }}
          onSetPaymentData={(data) => {
            if (creditCardOrAch?.value === constants.PAYMENT_TYPE_IDS.CREDIT_CARD) {
              saveManualDealerCard(data);
            } else if (creditCardOrAch?.value === constants.PAYMENT_TYPE_IDS.ACH_DEBIT) {
              saveACHDetails(data);
            }
          }}
          creditCardOrAch={creditCardOrAch}
          setCreditCardOrAch={setCreditCardOrAch}
          contractType={agreementNumber === constants.CASH_SALE ? constants.CONTRACT_TYPE.CASH_SALE : constants.CONTRACT_TYPE.RTO}
          confirmTransfer={confirmTransfer}
          setConfirmTransfer={setConfirmTransfer}
        />
      ) : null}
      {capturingCard ? (
        <Modal isOpen={true} autoFocus={false} centered>
          <ModalHeader>Swipe Credit Card</ModalHeader>
          <ModalBody>
            <Row className="mt-3 mb-1">
              <Col xs="4">
                <div className="float-end">{ui_helpers.requiredStar()}</div>
                <Input
                  type="text"
                  value={cardZip}
                  maxLength="12"
                  autoFocus={true}
                  style={{ width: "90%" }}
                  placeholder="Zip Code"
                  onChange={(e) => onChangeCardZip(e.target.value)}
                />
              </Col>
              <Col xs="8">
                <Input
                  type="password"
                  innerRef={cardSwipeRef}
                  autoComplete="new-password"
                  value={cardSwipe}
                  onChange={(e) => setCardSwipe(e.target.value)}
                  onKeyDown={swipeCreditCardKeydown}
                  readOnly={!cardZip || cardZip.length < 5}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              className="text-light"
              onClick={() => {
                setCardNo("");
                setCapturingCard(false);
                setCapturingCardManually(true);
              }}
            >
              Enter card details manually
            </Button>
            <Button
              color="secondary"
              className="float-end"
              onClick={() => setCapturingCard(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      ) : null}
      {capturingCardManually ? (
        <Modal isOpen={true} centered>
          <ModalHeader>Enter Card Information</ModalHeader>
          <ModalBody>
            <Card
              cvc={cardCVC}
              number={cardNo}
              expiration={cardMMYY}
              // name={""}
              focused={"name"}
            />
            <Row className="mt-3 mb-1">
              <Col xs="5">
                <Input
                  type="text"
                  bsSize="sm"
                  value={cardNo}
                  maxLength="20"
                  placeholder="Card number"
                  onChange={(e) => setCardNo(e.target.value)}
                />
              </Col>
              <Col xs="3">
                <Input
                  type="text"
                  bsSize="sm"
                  value={cardZip}
                  maxLength="12"
                  placeholder="Zip Code"
                  onChange={(e) => setCardZip(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="5">
                <Input
                  type="text"
                  bsSize="sm"
                  value={cardMMYY}
                  maxLength="4"
                  placeholder="MMYY"
                  onChange={(e) => setCardMMYY(e.target.value)}
                />
              </Col>
              <Col xs="3">
                <Input
                  type="text"
                  bsSize="sm"
                  value={cardCVC}
                  maxLength="5"
                  placeholder="CVC"
                  onChange={(e) => setCardCVC(e.target.value)}
                />
              </Col>
            </Row>
            {manualCard ? (
              <div className="mt-2">
                {manualCard.ErrorMessage ? (
                  <RSAlert color="warning" className="mb-0">
                    {manualCard.ErrorMessage}
                  </RSAlert>
                ) : (
                  <RSAlert color="success" className="mb-0">
                    The provided card information is valid.
                  </RSAlert>
                )}
              </div>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button
              color="warning"
              className="text-light"
              onClick={() => {
                const manualCardInfo = ui_helpers.parseManualCardInformation(
                  cardZip,
                  cardNo,
                  cardMMYY,
                  cardCVC
                );
                setManualCard(manualCardInfo);
              }}
            >
              Verify Card Information
            </Button>
            <ButtonGroup className="float-end">
              {manualCard &&
              !manualCard.ErrorMessage ? (
                <Button color="primary" onClick={saveManualCard}>
                  Save
                </Button>
              ) : null}
              <Button
                color="secondary"
                onClick={() => setCapturingCardManually(false)}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </Modal>
      ) : null}
      {capturingACH ? (
        <CaptureACH
          achPayment={achPayment}
          bankInformation={bankInformation}
          achValidation={achValidation}
          onAchPaymentChange={onAchPaymentChange}
          showAchValidation={showAchValidation}
          cleanseAchModal={cleanseAchModal}
          saveACH={saveACH}
        />
      ) : null}
      {showTransferModal ? (
        <TransferNowModal
          showTransferModal={showTransferModal}
          setShowTransferModal={setShowTransferModal}
          confirmTransferNow={confirmTransferNow}
          setConfirmTransferNow={setConfirmTransferNow}
          completeTransfer={onApplyPayment}
        />
      ) : null}
  </Row>);
};